const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
const isImageLoaded = (image: HTMLImageElement) => image.complete && image.naturalHeight !== 0;

export const waitForImages = (images: Array<HTMLImageElement>, interval = 200, max = 5) => {
  let counter = 0;

  return new Promise((resolve, reject) => {
    const checkIfLoaded = async (items: Array<HTMLImageElement>) => {
      const notLoadedImages = items.filter(image => !isImageLoaded(image));

      if (notLoadedImages.length) {
        counter += 1;
        if (counter > max) {
          reject(new Error('Timeout exceeded'));
        } else {
          await delay(counter * interval);
          checkIfLoaded(notLoadedImages);
        }
      } else {
        resolve(true);
      }
    };

    checkIfLoaded(images);
  });
};
